module.exports = {"id":"f47690a3-06f1-4b50-bbd1-77c6547b784f","name":"managers","items":[{"text":"","type":"inline","items":[{"name":"full-name","props":{"hidden":true,"formula":{"name":"join","arguments":{"targets":["first-name","last-name"]}},"width":"0"},"text":"","type":"text-field"},{"name":"first-name","props":{"label":"First Name","required":true,"width":"6"},"text":"","type":"text-field"},{"name":"last-name","props":{"label":"Last Name","required":true,"width":"6"},"text":"","type":"text-field"}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/entity-support-elite/data_table_forms/managers.json
// module id = etUr
// module chunks = 0